<div class="inner-page-header">
  <div class="titles">
    <h3 class="title">الاسئلة / Q-{{ question?.id }}</h3>
  </div>
</div>

<div class="question-wrapper">
  <div class="actions">
    @if (!isQuestionClosed() && !isQuestionOpen()) {
      <button type="button" class="btn btn-green" (click)="acceptQuestion()">
        <img src="assets/images/svg/check-green.svg" alt="accept" />
        قبول السؤال
      </button>
    }
    @if (!isQuestionClosed()) {
      <button type="button" class="btn btn-delete" (click)="closeQuestion()">إغلاق السؤال</button>
    }
  </div>

  <div class="question-details">
    <div class="main-card">
      <h3 class="font-18 font-bold">السؤال</h3>

      <h4 class="font-16">تفاصيل السؤال</h4>
      <p class="font-bold">{{ question?.content }}</p>

      <h4 class="font-16">الصور</h4>
      @if (question?.attachments?.length) {
        @for (attachment of question?.attachments; track attachment.id) {
          <a [href]="attachment.file_url" target="_blank">
            <img [src]="attachment.file_url" [alt]="attachment.file_name" class="question-attachment" />
          </a>
        }
      } @else {
        <img src="assets/images/svg/building-placeholder.svg" alt="building-placeholder" />
      }

      <div class="form-group mt-3">
        <label for="" class="form-label"> التخصص </label>
        <ng-select bindLabel="name_ar" (scrollToEnd)="onScrollSpecializationsPagination()" #selectSpecializations
          placeholder="يرجى تحديد التخصص" appendTo="body" [(ngModel)]="selectedSpecialization" [searchable]="true"
          (removed)="resetSpecializationsSearch()" (search)="searchSpecializationsText()"
          (clear)="resetSpecializationsSearch()" (change)="onSpecializationChange($event)"
          (open)="resetSpecializationsSearch()" [virtualScroll]="true" [clearable]="true">
          @for (specialization of specializations; track specialization.id) {
          <ng-option [value]="specialization.id">
            {{specialization.name_ar}}
          </ng-option>
          }
        </ng-select>
      </div>
    </div>

    <div class="main-card">
      <div class="details-title">
        <h3 class="font-18 font-bold">معلومات السؤال</h3>
        <div class="status" [ngClass]="getStatusClass(question?.status)">{{ getStatusLabel(question?.status) }}</div>
      </div>
      <div class="details-wrapper">
        <div class="basic-data">
          <h4>اسم العميل</h4>
          <div class="double-tooltip">
            <p>
              <a [href]="'/pages/customers/customer-profile/' + question?.client?.id" target="_blank" class="client-name-link">
                {{ getClientName() }}
              </a>
              <span class="custom-tooltip">
                <img src="assets/images/svg/phone-tooltip.svg" alt="" />
                <span class="tooltip-text clickable" (click)="copyClientMobile()">
                  {{ question?.client?.mobile || '-' }}
                  <img src="assets/images/svg/copy-report-link.svg" alt="copy"
                    style="width: 14px; height: 14px; margin-left: 4px; cursor: pointer;" />
                </span>
              </span>
              <span class="custom-tooltip">
                <img src="assets/images/svg/email-tooltip.svg" alt="" />
                <span class="tooltip-text">{{ question?.client?.email || '-' }}</span>
              </span>
            </p>

          </div>
        </div>
        <div class="basic-data">
          <h4> تاريخ الإنشاء</h4>
          <p><bdi>{{ question?.created_at | saudiDateTime }}</bdi></p>
        </div>
        <div class="basic-data">
          <h4> تاريخ الإغلاق</h4>
          <p><bdi>{{ question?.closed_at | saudiDateTime }}</bdi></p>
        </div>
        <div class="basic-data">
          <h4>التخصص</h4>
          <p>{{ question?.specialization?.name_ar || '-' }}</p>
        </div>
        <div class="basic-data">
          <h4> المجموعة</h4>
          <p>{{ question?.cohort?.name || '-' }}</p>
        </div>
        <div class="basic-data">
          <h4> رقم السؤال</h4>
          <p>Q-{{ question?.id }}</p>
        </div>
      </div>

      <h3 class="font-18 font-bold">فحوصات الذكاء الاصطناعي</h3>
      @if (getReviewReasonLabel(); as reviewReasonLabel) {
        <p class="ai-review-reason">{{ reviewReasonLabel }}</p>
      }
      @for (attempt of reviewAttempts; track attempt.attempt) {
        <div class="ai-attempt">
          <div class="ai-attempt-header">
            <h4 class="font-16 font-bold">{{ attempt.legacy ? 'نتيجة الفحص (قبل حفظ المحاولات)' : 'المحاولة ' + attempt.attempt }}</h4>
            @if (attempt.result) {
              <div class="status" [ngClass]="getAttemptResultClass(attempt.result)">{{ getAttemptResultLabel(attempt.result) }}</div>
            }
            <p><bdi>{{ attempt.created_at | saudiDateTime }}</bdi></p>
          </div>
          <p class="ai-attempt-content" [class.collapsed]="isAttemptContentLong(attempt) && !expandedAttempts.has(attempt.attempt)">{{ attempt.content }}</p>
          @if (isAttemptContentLong(attempt)) {
            <button type="button" class="ai-attempt-toggle" (click)="toggleAttemptContent(attempt.attempt)">
              {{ expandedAttempts.has(attempt.attempt) ? 'عرض أقل' : 'عرض المزيد' }}
            </button>
          }
          <div class="details-wrapper">
            <div class="basic-data">
              <h4>أمان الصورة</h4>
              <div class="status" [ngClass]="getCheckClass(attempt.checks.image.status)">{{ getCheckLabel(attempt.checks.image.status) }}</div>
              @if (!attempt.has_image) {
                <p class="ai-check-note">بدون صورة</p>
              }
            </div>
            <div class="basic-data">
              <h4>الصلة بالعقار</h4>
              @if (attempt.checks.relevance.status) {
                <div class="status" [ngClass]="getCheckClass(attempt.checks.relevance.status)">{{ getCheckLabel(attempt.checks.relevance.status) }}</div>
              }
              <p class="ai-check-note">
                الثقة {{ attempt.checks.relevance.score ?? '-' }} من 100، الحد المطلوب {{ attempt.checks.relevance.threshold ?? 'غير محفوظ' }}
              </p>
              <p class="ai-check-note">حكم الذكاء الاصطناعي: {{ getRelevantLabel(attempt.checks.relevance.relevant) }}</p>
            </div>
            <div class="basic-data">
              <h4>خلوّه من المعلومات الشخصية</h4>
              <div class="status" [ngClass]="getCheckClass(attempt.checks.pii.status)">{{ getCheckLabel(attempt.checks.pii.status) }}</div>
            </div>
          </div>
        </div>
      } @empty {
        <p class="ai-review-empty">تقييم الذكاء الاصطناعي غير متاح لهذا السؤال</p>
      }
    </div>
  </div>
</div>

<app-change-log [questionId]="questionId"></app-change-log>

<app-answers-log [questionId]="questionId"></app-answers-log>
